
import { APIPaths } from '@bcm/apis';
import axios from 'axios';
import env from '../../constants/env';
import { StatusCodes } from 'http-status-codes';



export const contact = (email, name, subject, message) => async () => {

	let params = {
		url: `${env.REST_API_GATEWAY}${APIPaths.websitePostContact.RESTPath}`,
		method: APIPaths.websitePostContact.method,
		data: {
			email,
			name: `${subject} FROM ${name}`,
			message,
		}
	};
	try {
		const res = await axios(params);
		return res;
	}
	catch (err) {
		return {
			status: StatusCodes.INTERNAL_SERVER_ERROR
		};
	}
};
